import { isTextNode, isWidgetNode } from '../../nodes/helpers';
import { deserializeFeedString } from '../../serialization/property-value-serializer';
import { isVariableSpan } from '../rich-text/utils';
export function normalizeFeedPath(path) {
    return path.replace(/\s+/g, ' ').trim();
}
export function normalizeFeedData(feedData) {
    const normalizedFeedData = {
        data: [],
        intervalInSeconds: feedData.intervalInSeconds
    };
    for (const item of feedData.data) {
        const feedValue = {};
        for (const key of Object.keys(item)) {
            const path = normalizeFeedPath(key);
            const value = item[key].value;
            const targetUrl = item[key].targetUrl;
            feedValue[path] = {
                value: value === null ? undefined : value,
                targetUrl: targetUrl === null ? undefined : targetUrl
            };
        }
        normalizedFeedData.data.push(feedValue);
    }
    return normalizedFeedData;
}
export function encodeFeedPath(path) {
    return path.replace(/\s/g, '%20');
}
export function decodeFeedPath(path) {
    return path.replace(/%20/g, ' ');
}
export function createFeed(id, path = '', type = 'text') {
    const feed = {
        id: id,
        path: encodeFeedPath(path !== null && path !== void 0 ? path : ''),
        step: {
            occurrence: 'loop',
            size: 1,
            start: 1
        },
        fallback: '',
        type: type
    };
    return feed;
}
export function createVariable(id, path = '') {
    return Object.assign(Object.assign({}, createFeed(id, path, 'text')), { type: 'text' });
}
export function isCustomFeedProperty(customProperty) {
    return customProperty.unit === 'feed';
}
export function isFeedValue(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    if ('id' in value && 'path' in value && 'step' in value) {
        return true;
    }
    return false;
}
export function isVersionedFeed(property) {
    return isFeedValue(property.value);
}
export function hasTextFeed(element) {
    var _a;
    const content = ((_a = element.__dirtyContent) === null || _a === void 0 ? void 0 : _a.spans) || element.content.spans;
    for (const span of content) {
        if (isVariableSpan(span)) {
            return true;
        }
    }
    return false;
}
export function hasWidgetFeed(element) {
    for (const property of element.customProperties) {
        try {
            if (isCustomFeedProperty(property)) {
                const feed = deserializeFeedString(property.value);
                if (feed === null || feed === void 0 ? void 0 : feed.id) {
                    return true;
                }
            }
        }
        catch (_a) {
            throw new Error(`Failed to parse widget property ${property.unit} - "${property.name}" value "${property.value}"`);
        }
    }
    return false;
}
export function hasFeededContent(element) {
    if (element.feed) {
        return true;
    }
    if (isTextNode(element)) {
        const hasFeed = hasTextFeed(element);
        if (hasFeed) {
            return true;
        }
    }
    if (isWidgetNode(element)) {
        const hasFeed = hasWidgetFeed(element);
        if (hasFeed) {
            return true;
        }
    }
    return false;
}
// extracts all feed ids from a given element. Text & widgets can contain multiple feeds.
export function getFeedIds(element) {
    var _a;
    if (element.feed) {
        return [element.feed.id];
    }
    const feedIds = new Set();
    if (isTextNode(element)) {
        const content = ((_a = element.__dirtyContent) === null || _a === void 0 ? void 0 : _a.spans) || element.content.spans;
        for (const span of content) {
            if (isVariableSpan(span) && span.style.variable) {
                feedIds.add(span.style.variable.id);
            }
        }
    }
    if (isWidgetNode(element)) {
        for (const property of element.customProperties) {
            try {
                if (isCustomFeedProperty(property)) {
                    const feed = deserializeFeedString(property.value);
                    if (feed === null || feed === void 0 ? void 0 : feed.id) {
                        feedIds.add(feed.id);
                    }
                }
            }
            catch (_b) {
                throw new Error(`Failed to parse widget property ${property.unit} - "${property.name}" value "${property.value}"`);
            }
        }
    }
    return [...feedIds];
}
export function isFeedpathProperty(property) {
    return property.name.indexOf('feedPath') > -1;
}
